<template>
  <el-dialog
    :visible="visible"
    :title="$t('components.refreshAlertDialog.title')"
    @update:visible="setVisibility($event)"
    @close="emitAbort"
  >
    <p
      v-if="versionMismatch"
      v-t="{
        path: 'components.refreshAlertDialog.versionMismatchText',
        args: { version, remoteVersion },
      }"
      class="mt-0"
    ></p>

    <p
      v-t="{
        path: 'components.refreshAlertDialog.text',
        args: { duration: duration.format('s [__]') },
      }"
      class="mt-0"
    ></p>

    <el-divider/>

    <div class="d-flex justify-content-end">
      <el-button @click="onClickAbort" v-t="'common.abort'"/>
      <el-button type="primary" @click="emitRefresh" v-t="'common.refresh'"/>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment';
import config from '@/config';
import Clock from '@/lib/clock';

export default {
  name: 'RefreshAlertDialog',
  data() {
    return {
      version: config.version,
      clock: new Clock(),
    };
  },
  props: {
    visible: { type: Boolean, default: false },
    remoteVersion: { type: String },
    refreshPageAt: { type: Date, default: null },
  },
  computed: {
    versionMismatch() {
      return this.version !== this.remoteVersion;
    },
    duration() {
      const now = moment(this.clock.now);
      const refreshPageAt = moment(this.refreshPageAt);
      return moment.duration(refreshPageAt.diff(now));
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.clock.start();
      } else {
        this.clock.stop();
      }
    },
  },
  methods: {
    setVisibility(value) {
      this.$emit('update:visible', value);
    },
    emitAbort() {
      this.$emit('click:abort');
    },
    emitRefresh() {
      this.$emit('click:refresh');
    },
    onClickAbort() {
      this.setVisibility(false);
      this.emitAbort();
    },
  },
  beforeDestroy() {
    this.clock.stop();
  },
};
</script>

<style scoped>

</style>
